module.exports = __webpack_public_path__ + "img/margarita-mahi-mahi-fillets.7cd710bb.jpg";